<!-- A dialog to promote the Content Creator feature using a video.

Originally created for the Bauvista-Workflow:

  - https://github.com/myshopradio/cms/issues/2157
  - https://github.com/myshopradio/cms/issues/2119

The video is client-specific and currently passed to the app as:

  $userprofile.promote_content_creator_video_url

-->
<template>
  <div>
    <v-dialog
      scrollable
      :value="show"
      :width="$store.state.common.extraLargeDialogWidth"
      persistent
      @input="(val) => $emit('update:show', val)"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-layout align-center>
            <v-layout
              align-center
              wrap
            >
              <div class="headline">
                {{ $t('contentCreatorLandingPageTitle') }}
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <video
            v-if="show && !!promotionVideoUrl"
            :src="promotionVideoUrl"
            preload="metadata"
            width="100%"
            controls
            autoplay
          />
        </v-card-text>
        <v-card-actions class="pt-0 pb-3">
          <v-spacer />
          <v-btn
            large
            round
            color="msr"
            dark
            :title="$t('contentCreatorCurrentPlanFreeDefaultUpgradeNow')"
            @click="goToContentCreatorBookingPage()"
          >
            {{ $t('contentCreatorCurrentPlanFreeDefaultUpgradeNow') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    promotionVideoUrl() {
      if (!this.$user) {
        return '';
      }
      return this.$userprofile.promote_content_creator_video_url;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    goToContentCreatorBookingPage() {
      this.close();
      this.$router.push({name: 'contentcreatorlanding'});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PromoteContentCreatorDialog.vue